import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@betareader/design-system';
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import gaTracker from '../../utils/gaTracker';
import {
  fetchCurrentReader,
  clearCurrentReader,
  sendInvitation,
} from '../../modules/reader';

import ReadingSessionsFeed from './readingSessionsFeed';
import ReadingGraph from './readingGraph';

const Page = styled.main`
  margin: 0 auto;
  max-width: 1100px;
  padding: var(--br-space-4);
`;

const Columns = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;

export class Reader extends Component {
  componentDidMount() {
    gaTracker.trackPageView(this.props.match.path);
    this.loadReader();
  }

  componentDidUpdate(previousProps) {
    if (this.props.currentBook?._id !== previousProps.currentBook?._id ||
      this.props.idToken !== previousProps.idToken ||
      this.props.match.params.readerId !== previousProps.match.params.readerId) {
      this.loadReader();
    }
  }

  componentWillUnmount() {
    this.props.clearCurrentReader();
  }

  loadReader = () => {
    const { idToken, currentBook, match } = this.props;
    const readerId = match.params.readerId;
    if (idToken && currentBook?._id && readerId) {
      this.props.fetchCurrentReader(idToken, { bookId: currentBook._id, readerId });
    }
  }

  sendInvitation = () => {
    const { idToken, currentBook, currentReader } = this.props;
    if (idToken && currentReader && currentBook?._id) {
      this.props.sendInvitation(idToken, {
        ...currentReader,
        book: currentReader.book || currentBook._id,
      });
    }
  }

  render() {
    const { currentReader: reader, currentBook, updatingReader } = this.props;
    if (!reader) {
      return <Page><p role='status'>Loading reader…</p></Page>;
    }

    const invitation = reader.invitation || {};
    const sending = updatingReader === reader._id;
    return (
      <Page>
        <Columns>
          <section>
            <h1>{reader.name}</h1>
            {invitation.status === 'SENT' && (
              <p>Not yet started. (Invited on {new Date(invitation.sentAt).toLocaleDateString()}) {sending && 'Sending invitation'}</p>
            )}
            {invitation.status === 'CREATED' && (
              <p>
                Not yet started. No invitation sent.{' '}
                <Button variant='secondary' size='small' disabled={sending} onClick={this.sendInvitation}>
                  {sending ? 'Sending invitation' : 'Send invitation'}
                </Button>
              </p>
            )}
            {invitation.status === 'ACCEPTED' && currentBook && (
              <ReadingGraph lastRead={reader.lastRead} chapters={currentBook.parts} />
            )}
            {invitation.status === 'ABANDONED' && (
              <div>
                <p>Abandoned reading on {new Date(invitation.abandonedAt).toLocaleDateString()}</p>
                {reader.exitReason?.feedback && <p><strong>Feedback:</strong> {reader.exitReason.feedback}</p>}
              </div>
            )}
          </section>
          <section>
            <h2>Activity</h2>
            <ReadingSessionsFeed />
          </section>
        </Columns>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  updatingReader: state.reader.updatingReader,
  currentReader: state.reader.currentReader
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCurrentReader,
  clearCurrentReader,
  sendInvitation,
  changePage: newPage => push(newPage)
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Reader));
